import { publicConfig } from '@public-config';

import { SlackChannel } from 'models';

import { ApiService } from './ApiService';

const SlackNotificationService = {
    send: async (message: string, channel?: SlackChannel) => {
        return ApiService.post(
            `${publicConfig.urls.api}/send-slack-notification`,
            { message, channel },
            { throwError: true },
        );
    },
};

export { SlackNotificationService };
